<ion-row align-self-strech>
  <ion-col class="listing-item">
    <div class="item-image-wrapper">
      <a class="image-anchor" [routerLink]="['/papeleria/catalogo', card.slug]">
        <img [src]="card.image" class="left" />
      </a>
    </div>
    <ion-row class="item-body">
      <ion-col size="12" class="main-info">
        <h4 class="item-name">
          <a class="name-anchor" [routerLink]="['/papeleria/catalogo', card.slug]">
            {{ card.title }}
          </a>
        </h4>
      </ion-col>
      <ion-col size="12">
        <ion-row class="secondary-info">
          <ion-col class="price-col">
            <span class="item-sale-price">
              {{ card.salePrice | currency: '€' }}
            </span>
          </ion-col>
          <ng-container *ngIf="card.price != '0'">
            <ion-col class="separator"> </ion-col>
            <ion-col class="price-col">
              <span class="item-original-price">
                {{ card.price | currency: '€' }}
              </span>
            </ion-col>
          </ng-container>
          <ion-button size="small" (click)="onCart(card)">
            <ion-icon name="cart-outline"></ion-icon>
          </ion-button>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
